import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura';

const CustomTheme = definePreset(Aura, {
  semantic: {
    primary: {
      100: "#cfddd9",
      200: "#a0bbb3",
      300: "#709a8c",
      400: "#1E7F88",
      500: "#1E7F88",
      600: "#1E7F88",
      700: "#1E7F88",
      800: "#1E7F88",
      900: "#03110d"
    }
  },
  extend: {
    // Colori success personalizzati
    success: {
      50: "#f1f8e9",
      100: "#dbf1d6",
      200: "#b8e2ad", 
      300: "#94d485",
      400: "#1E7F88",
      500: "#1E7F88",
      600: "#1E7F88",
      700: "#1E7F88",
      800: "#1E7F88",
      900: "#0f250a"
    },
    // Colori danger personalizzati  
    danger: {
      50: "#ffebee",
      100: "#f4cccc",
      200: "#ea9999",
      300: "#df6666", 
      400: "#d53333",
      500: "#ca0000",
      600: "#a20000",
      700: "#790000",
      800: "#510000",
      900: "#280000"
    },
    // Variabili di convenienza
    successColor: "#1E7F88",
    dangerColor: "#ca0000",
    successLight: "#dbf1d6",
    dangerLight: "#f4cccc"
  }
})

export default CustomTheme

